// @flow
// import { Link } from 'react-router-dom'
import React, { Component } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
// import ReactPaginate from 'react-paginate'
import { LocaleContext } from '../../contexts/locale'
import config from 'config'
import './styles.scss'

import ClubFilter from 'components/clubFilter'

// Importing localised strings
import de from './locales/de.yml'
import fr from './locales/fr.yml'

export type VotePreference = {
  hornkuh: boolean | null,
  sbi: boolean | null,
  ueberwachung: boolean | null
}

type Props = {
  handleTeamSelection: (teamId: number) => void
}

type State = {
  votePreference: VotePreference
}

type Club = {
  Number: Number,
  Name: string,
  AssociationName: string,
  TeamsCount: Number
}

/* type Team = {
  id: number,
  name: string
} */

const MESSAGES = { de, fr }

// const associations: Array<Association> = require('./data/associations.csv')
const clubs: Array<Club> = require('../../data/clubs.csv')

export class ClubsList extends Component<Props, State> {
  state: State = {
    clubs: clubs,
    selectedAssociations: []
  }

  componentWillMount() {
    console.log(this.state.clubs)
  }

  handleRegionFilterSelection(associationName) {
    const associations = this.state.selectedAssociations
    let selectedAssociations = []

    if (!associations.includes(associationName)) {
      selectedAssociations = [associationName, ...associations]
    } else {
      selectedAssociations = associations.filter(
        item => item !== associationName
      )
    }

    this.setState({
      selectedAssociations: selectedAssociations,
      clubs: clubs.filter(item =>
        selectedAssociations.includes(item.AssociationName)
      )
    })
  }

  static contextType = LocaleContext

  render() {
    const t = config.translationServiceFactory(MESSAGES, this.context)

    return (
      <>
        {/* <div className='results ui bottom attached segment'>
          {associations.map((c, i) =>
            <div
              className={this.state.selectedAssociations.includes(c['Name']) ? 'ative item' : 'item'}
              tabIndex={0}
              key={i}
              onClick={() => this.handleRegionFilterSelection(c['Name'])}>
              {c['Name']}
            </div>)}
          </div> */}
        <ClubFilter
          label={t('searchLabel')}
          onSelectionHandler={this.props.handleTeamSelection}
        />
        {/* <div className='results ui bottom attached segment'>
          {this.state.clubs.map((c, i) =>
            <div
              className='item'
              tabIndex={0}
              key={i}
              onClick={() => console.log(c['Number'])}>
              <div className='header'>{c.Name}</div>
                  <div className='meta'>
                    {c.AssociationName}
                  </div>
            </div>)}
          </div> */}
        {/* <div className='results ui bottom attached segment'>
          <ReactPaginate
              previousLabel={'previous'}
              nextLabel={'next'}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.handlePageClick}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
            />
        </div> */}
      </>
    )
  }
}

export default ClubsList
